import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";
import {GiftIcon} from "@heroicons/react/24/solid";
import useTranslation from "@babackapp/translations/use-translation";

type DiscountCodeActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function DiscountCodeActivity({ activity }: DiscountCodeActivityProps) {
  const t = useTranslation();
  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <GiftIcon className="size-3" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <ActivityItemHeader
          title={t("activities.discountCode.title") + " : " + activity.comment}
          timestamp={activity.date}
        />
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
